// extracted by mini-css-extract-plugin
export default {"title":"ForthScreen_title__35pUX","description":"ForthScreen_description__RUpwg"};